import { render, staticRenderFns } from "./BtnCreerRecom.vue?vue&type=template&id=36d2d216"
import script from "./BtnCreerRecom.vue?vue&type=script&lang=js"
export * from "./BtnCreerRecom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports